import ExtendedImage from 'client/common/components/extended-image';

export default ExtendedImage;
